/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import ic_setting_big from "../../assets/images/pictures/icon/ic_settings_big.svg";
import ic_github_big from "../../assets/images/pictures/icon/ic_big_github.svg";
import ic_phone_setting_big from "../../assets/images/pictures/icon/ic_phone-settings_big.svg";
import ic_chat_big from "../../assets/images/pictures/icon/ic_chat_big.svg";
import ic_code_big_circle from "../../assets/images/pictures/icon/ic_code_circle.svg";
import ic_devices_circle from "../../assets/images/pictures/icon/ic_devices_circle.svg";
import ic_doc_circle from "../../assets/images/pictures/icon/ic_doc_circle.svg";
import ic_doc_code_circle from "../../assets/images/pictures/icon/ic_doc-code_circle.svg";
import ic_person_circle from "../../assets/images/pictures/icon/ic_person_circle.svg";
import ic_person_code_circle from "../../assets/images/pictures/icon/ic_person-code_circle.svg";
import ic_setting_circle from "../../assets/images/pictures/icon/ic_settings_circle.svg";
import ic_gopaperless from "../../assets/images/pictures/icon/ic_gopaperless.svg";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import Footer from "./../global/Footer";
import NavbarBottom from "./../global/NavbarBottom";

const DocumentContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div id="dev-page">
        <div className="container px-md-0">
          <div className="row text-center " style={{ marginTop: "40px" }}>
            <div className="col-md-12">
              <h2 className="font-weight-bold mx-auto">
                {t("document.note1")}
              </h2>
              <p
                style={{
                  marginTop: "10px",
                  lineHeight: "20px",
                  whiteSpace: "normal",
                }}
              >
                {" "}
                {t("document.note2")}
              </p>
            </div>
          </div>
          <div
            className="container"
            style={{ marginTop: "30px", marginBottom: "40px" }}
          >
            <div className="row">
              <a
                href="https://gopaperless.mobile-id.vn/uploads/GoPaperless_Agent_Whitepaper_v2.pdf"
                target="_blank"
                rel="noopener noreferrer"
                title={t("document.note3")}
                download={true}
                className="col-sm-4 d-flex"
                style={{ textDecoration: "none" }}
              >
                <div style={{ cursor: "pointer" }}>
                  <div
                    className="text-center"
                    style={{
                      borderRadius: "20px",
                      border: "1px solid rgb(238,238,238)",
                      padding: "30px 20px",
                      boxShadow: "rgba(0,0,0,0.05) 0px 2px 10px",
                      transition: "0.3s ease-in-out",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "rgb(136,136,136)",
                        textTransform: "uppercase",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      GoPaperless Agent
                    </div>
                    <p
                      style={{
                        color: "rgb(0,123,255)",
                        fontWeight: 600,
                        marginTop: "30px",
                        lineHeight: "20px",
                      }}
                    >
                      {t("document.agent_note2")}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "rgb(85,85,85)",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.agent_note")}
                      <br />
                      {t("document.agent_note0")}
                    </p>
                  </div>
                </div>
              </a>
              <a
                href="https://gopaperless.mobile-id.vn/uploads/Sales_Teams_and_GoPaperless.pdf"
                target="_blank"
                rel="noopener noreferrer"
                title={t("document.note3")}
                download={true}
                className="col-sm-4 d-flex"
                style={{ textDecoration: "none" }}
              >
                <div style={{ cursor: "pointer" }}>
                  <div
                    className="text-center"
                    style={{
                      borderRadius: "20px",
                      border: "1px solid rgb(238,238,238)",
                      padding: "30px 20px",
                      boxShadow: "rgba(0,0,0,0.05) 0px 2px 10px",
                      transition: "0.3s ease-in-out",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "rgb(136,136,136)",
                        textTransform: "uppercase",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note4")}
                    </div>
                    <p
                      style={{
                        color: "rgb(0,123,255)",
                        fontWeight: 600,
                        marginTop: "30px",
                        lineHeight: "20px",
                      }}
                    >
                      {t("document.note5")}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "rgb(85,85,85)",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note6")}
                    </p>
                  </div>
                </div>
              </a>
              <a
                href="https://gopaperless.mobile-id.vn/uploads/GoPaperless_and_Telecommunications.pdf"
                target="_blank"
                rel="noopener noreferrer"
                title={t("document.note3")}
                download={true}
                className="col-sm-4 d-flex"
                style={{ textDecoration: "none" }}
              >
                <div style={{ cursor: "pointer" }}>
                  <div
                    className="text-center"
                    style={{
                      borderRadius: "20px",
                      border: "1px solid rgb(238,238,238)",
                      padding: "30px 20px",
                      boxShadow: "rgba(0,0,0,0.05) 0px 2px 10px",
                      transition: "0.3s ease-in-out",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "rgb(136,136,136)",
                        textTransform: "uppercase",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note7")}
                    </div>
                    <p
                      style={{
                        color: "rgb(0,123,255)",
                        fontWeight: 600,
                        marginTop: "30px",
                        lineHeight: "20px",
                      }}
                    >
                      {t("document.note8")}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "rgb(85,85,85)",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note9")}
                    </p>
                  </div>
                </div>
              </a>
              <a
                href="https://gopaperless.mobile-id.vn/uploads/Brochure_GoPaperless.pdf"
                target="_blank"
                rel="noopener noreferrer"
                title={t("document.note3")}
                download={true}
                className="col-sm-4 d-flex"
                style={{ textDecoration: "none" }}
              >
                <div style={{ cursor: "pointer" }}>
                  <div
                    className="text-center"
                    style={{
                      borderRadius: "20px",
                      border: "1px solid rgb(238,238,238)",
                      padding: "30px 20px",
                      boxShadow: "rgba(0,0,0,0.05) 0px 2px 10px",
                      transition: "0.3s ease-in-out",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "rgb(136,136,136)",
                        textTransform: "uppercase",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note4")}
                    </div>
                    <p
                      style={{
                        color: "rgb(0,123,255)",
                        fontWeight: 600,
                        marginTop: "30px",
                        lineHeight: "20px",
                      }}
                    >
                      {t("document.note10")}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "rgb(85,85,85)",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note11")}
                    </p>
                  </div>
                </div>
              </a>
              <a
                href="https://gopaperless.mobile-id.vn/uploads/GoPaperless_and_Public_Sector.pdf"
                target="_blank"
                rel="noopener noreferrer"
                title={t("document.note3")}
                download={true}
                className="col-sm-4 d-flex"
                style={{ textDecoration: "none" }}
              >
                <div style={{ cursor: "pointer" }}>
                  <div
                    className="text-center"
                    style={{
                      borderRadius: "20px",
                      border: "1px solid rgb(238,238,238)",
                      padding: "30px 20px",
                      boxShadow: "rgba(0,0,0,0.05) 0px 2px 10px",
                      transition: "0.3s ease-in-out",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "rgb(136,136,136)",
                        textTransform: "uppercase",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note4")}
                    </div>
                    <p
                      style={{
                        color: "rgb(0,123,255)",
                        fontWeight: 600,
                        marginTop: "30px",
                        lineHeight: "20px",
                      }}
                    >
                      {t("document.note12")}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "rgb(85,85,85)",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note13")}
                    </p>
                  </div>
                </div>
              </a>
              <a
                href="https://gopaperless.mobile-id.vn/uploads/Procurement_Teams_and_GoPaperless.pdf"
                target="_blank"
                rel="noopener noreferrer"
                title={t("document.note3")}
                download={true}
                className="col-sm-4 d-flex"
                style={{ textDecoration: "none" }}
              >
                <div style={{ cursor: "pointer" }}>
                  <div
                    className="text-center"
                    style={{
                      borderRadius: "20px",
                      border: "1px solid rgb(238,238,238)",
                      padding: "30px 20px",
                      boxShadow: "rgba(0,0,0,0.05) 0px 2px 10px",
                      transition: "0.3s ease-in-out",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "rgb(136,136,136)",
                        textTransform: "uppercase",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note4")}
                    </div>
                    <p
                      style={{
                        color: "rgb(0,123,255)",
                        fontWeight: 600,
                        marginTop: "30px",
                        lineHeight: "20px",
                      }}
                    >
                      {t("document.note14")}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "rgb(85,85,85)",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note15")}
                    </p>
                  </div>
                </div>
              </a>
              <a
                href="https://gopaperless.mobile-id.vn/uploads/Legal_Teams_and_GoPaperless.pdf"
                target="_blank"
                rel="noopener noreferrer"
                title={t("document.note3")}
                download={true}
                className="col-sm-4 d-flex"
                style={{ textDecoration: "none" }}
              >
                <div style={{ cursor: "pointer" }}>
                  <div
                    className="text-center"
                    style={{
                      borderRadius: "20px",
                      border: "1px solid rgb(238,238,238)",
                      padding: "30px 20px",
                      boxShadow: "rgba(0,0,0,0.05) 0px 2px 10px",
                      transition: "0.3s ease-in-out",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "rgb(136,136,136)",
                        textTransform: "uppercase",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note4")}
                    </div>
                    <p
                      style={{
                        color: "rgb(0,123,255)",
                        fontWeight: 600,
                        marginTop: "30px",
                        lineHeight: "20px",
                      }}
                    >
                      {t("document.note16")}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "rgb(85,85,85)",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note17")}
                    </p>
                  </div>
                </div>
              </a>
              <a
                href="https://gopaperless.mobile-id.vn/uploads/HR_Teams_and_GoPaperless.pdf"
                target="_blank"
                rel="noopener noreferrer"
                title={t("document.note3")}
                download={true}
                className="col-sm-4 d-flex"
                style={{ textDecoration: "none" }}
              >
                <div style={{ cursor: "pointer" }}>
                  <div
                    className="text-center"
                    style={{
                      borderRadius: "20px",
                      border: "1px solid rgb(238,238,238)",
                      padding: "30px 20px",
                      boxShadow: "rgba(0,0,0,0.05) 0px 2px 10px",
                      transition: "0.3s ease-in-out",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "rgb(136,136,136)",
                        textTransform: "uppercase",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note4")}
                    </div>
                    <p
                      style={{
                        color: "rgb(0,123,255)",
                        fontWeight: 600,
                        marginTop: "30px",
                        lineHeight: "20px",
                      }}
                    >
                      {t("document.note18")}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "rgb(85,85,85)",
                        lineHeight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      {t("document.note19")}
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-color">
        <div className="container security-footer">
          <div className="row">
            <div className="col-sm-8 col-sm-offset-2 text-center mbt-40">
              <img
                alt="GoPaperless"
                src={ic_gopaperless}
                data-no-retina=""
                width="64"
                height="64"
              />
              <h2 className="font-weight-bold">
                {t("developers-page.developers-page-content.content-3.heading")}
              </h2>
              <p>
                {t(
                  "developers-page.developers-page-content.content-3.description",
                )}
              </p>
              <a className="btn-secondary" href="/compliance">
                {t(
                  "developers-page.developers-page-content.content-3.button-learnmore",
                )}
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default DocumentContent;
